import React, { Component } from 'react'
import * as actions from "../actions";

export const EditPollLink = React.createClass({
  shouldComponentUpdate: function() {
    return false;
  },
  render: function() {
    return (
      <span className="edit">
        <a onClick={ this.handleEditClick } >(Edit)
        </a>
      </span>
    )
  },
  handleEditClick: function() {
    actions.editPoll(this.props.pollId);
  }
});



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/polls/components/edit-poll.es6